export default __webpack_public_path__ + "static/media/1749.12a34a65.png";